

























































import Vue from "vue";
import Component from "vue-class-component";
import { FixedTerm as FixedTermInterface } from "../../services/language/entities/fixed-term.interface";
import FixedTerm from "../../components/admin/FixedTerm.vue";
import { Watch } from "vue-property-decorator";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component({
  components: {
    FixedTerm
  }
})
export default class FixedTerms extends Vue {
  loadingFixedTerms = false;
  loadingRefresh = false;
  dialogCreate = false;
  page = 1;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private created(): void {
    this.loadingFixedTerms = true;
    this.$store
      .dispatch("language/getFixedTerms", {
        start: 0,
        quantity: constants.ITEMS_PER_PAGE
      })
      .finally(() => {
        this.loadingFixedTerms = false;
      });
  }

  private refreshTerms(): void {
    this.loadingRefresh = true;
    this.$store.dispatch("language/getFixedTerms").finally(() => {
      this.loadingRefresh = false;
    });
  }

  private get fixedTerms(): Array<FixedTermInterface> {
    return this.$store.getters["language/getFixedTerms"];
  }

  private get totalFixedTerms(): number {
    const totalFixedTerms = this.$store.getters["language/getTotalFixedTerms"];
    return totalFixedTerms;
  }

  @Watch("page")
  private getFixedTerms(): void {
    this.loadingFixedTerms = true;
    this.$store
      .dispatch("language/getFixedTerms", {
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .finally(() => {
        window.scrollTo(0, 0);
        this.loadingFixedTerms = false;
      });
  }

  private get totalPages(): number {
    const fixedTerms = this.totalFixedTerms;
    const total = fixedTerms / constants.ITEMS_PER_PAGE;
    if (total > Math.round(total)) {
      return Math.round(total) + 1;
    } else {
      return Math.round(total);
    }
  }
}
